/**
 * Prerender detection utility for react-snap
 * 
 * react-snap crawls the built app in a headless browser (Puppeteer)
 * with userAgent set to 'ReactSnap'. During this phase, the backend
 * API server is NOT running, so all API calls will fail and return
 * HTML error pages instead of JSON — causing the
 * "SyntaxError: Unexpected token '<'" crash.
 *
 * Use this utility to skip API calls, socket connections, and other
 * runtime-only logic during the prerender phase.
 */

export const isPrerendering = () => {
  if (typeof window === 'undefined') return true;
  if (window.__isPrerendering) return true;
  if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') return true;
  return false;
};
